import { render, staticRenderFns } from "./InputParagraph.vue?vue&type=template&id=70b21b5c&scoped=true&"
import script from "./InputParagraph.vue?vue&type=script&lang=js&"
export * from "./InputParagraph.vue?vue&type=script&lang=js&"
import style0 from "./InputParagraph.vue?vue&type=style&index=0&id=70b21b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b21b5c",
  null
  
)

export default component.exports